<style lang="scss" scoped>
.empty-page-container {
	margin-top: -30px;
	.empty-shipments-page {
		display: flex;
		height: calc(100vh - 80px);
		background-image: url('../../assets/empty-backdrop.png');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
}
</style>

<template>
    <div :class="{ 'empty-page-container' : (offers.length === 0) }">
        <div v-if="offers.length > 0" class="row can-blur">
            <div class="col-12 col-lg-6 col-xxl-4" v-for="offer in offers" :key="offer.id">
                <shipment-card class="mb-45" :item="offer.shipment" :offer="offer" type="offer-detail" shipmenttype="offer" :disabled="offer.shipment_status !== 'pending'"></shipment-card>
            </div>
        </div>

        <div v-else class="empty-shipments-page row">
            <div class="col-4 m-auto text-center">
                <p class="mb-0 text-secondary fs-24 fw-semi-bold mb-15">{{ $t('offer.notavailable') }}</p>
                <p class="mb-0 fs-18 fw-normal mb-30">{{ $t('offer.notavailabledisclaimer') }}</p>
                <router-link class="btn btn-primary" :to="{ name: 'search'}">{{ $t('shipments.search') }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ShipmentCard from '@/components/shipments/card'

export default {
	components: {
		ShipmentCard
	},
	data() {
		return {}
	},

	methods: {
	  ...mapActions(['getOffers'])
	},

	mounted() {
		this.getOffers()

	},
	computed: {
		...mapGetters(['offers'])
	}
}
</script>
